/**
 * Rule label → program: the fan-out half of an eligibility rule's line.
 *
 * A horizontal curve in both line styles. That is the one deliberate curve in the default
 * style: navigation is right-angled everywhere, so a curved line reads as "eligibility"
 * before any colour or label does.
 */
import { BaseEdge, type EdgeProps } from '@xyflow/react';

import { hCurve } from '../../utils/edgePaths';

export default function GrantEdge({ id, sourceX, sourceY, targetX, targetY, style, markerEnd }: EdgeProps) {
  return (
    <BaseEdge
      id={id}
      path={hCurve({ x: sourceX, y: sourceY }, { x: targetX, y: targetY })}
      style={style}
      markerEnd={markerEnd}
    />
  );
}
